import { api } from '../configs/axiosConfigs';

const createSavedSearchCriteria = async (requestBody) => {
  return await api.post('/property_search_criteria.json', requestBody);
};

export default createSavedSearchCriteria;
